import * as React from "react";
import { Modal, ModalBody } from "reactstrap";
import { withTracking } from "react-tracker";
import { FaChevronRight } from "react-icons/fa";
import { useLocation } from "react-router-dom";

import { interaction } from "../events";
import useStopWatch from "../../../hooks/useStopWatch";

import "./Card.scss";

const mapTrackingToProps = (trackEvent) => ({
  trackInteraction: (data) => trackEvent(interaction(data)),
});

function VideoPlayer(props) {
  const { title, description, imgUrl, url, trackInteraction, id } = props;

  const [isVideoPlayerOpen, setIsVideoPlayerOpen] = React.useState(false);

  const toggleVideoPlayerOpen = () => setIsVideoPlayerOpen(!isVideoPlayerOpen);

  const { pathname } = useLocation();

  const PAGE_NAME = pathname.split("/")[1].toUpperCase() || "N/A";

  const { start, reset, stop, time } = useStopWatch();

  const trackOnPlay = (event, callback) => {
    start();

    trackInteraction({
      action: event.currentTarget.dataset?.action,
      page: PAGE_NAME,
      element: event.currentTarget.dataset?.element,
    });

    callback();
  };

  const onCloseVideo = () => {
    stop();

    trackInteraction({
      action: "PLAY_VIDEO_TIME",
      page: PAGE_NAME,
      element: title,
      resourceId: id,
      value: time.format.long,
    });

    reset();
    toggleVideoPlayerOpen();
  };

  return (
    <div className="contents-card">
      <img src={imgUrl} alt={title} />

      <div className="contents-card-content">
        <span className="contents-card-title">{title}</span>
        <span className="contents-card-description">{description}</span>
        <button
          className="contents-card-button"
          data-action="CLICK_PLAY_VIDEO"
          data-element={title}
          onClick={(event) => trackOnPlay(event, toggleVideoPlayerOpen)}
        >
          Reproducir <FaChevronRight />
        </button>
      </div>
      <Modal
        element={title}
        isOpen={isVideoPlayerOpen}
        toggle={() => onCloseVideo(time)}
        centered
        size="lg"
      >
        <ModalBody style={{ height: "50vh" }}>
          <h3>{title}</h3>
          <iframe
            src={`${url}?autoplay=1`}
            width="100%"
            height="90%"
            frameBorder="0"
            allow="autoplay; fullscreen;"
            title={title}
          ></iframe>
        </ModalBody>
      </Modal>
    </div>
  );
}

const VideoPlayerWithTracking = withTracking(mapTrackingToProps)(VideoPlayer);

function Card(props) {
  const {
    title,
    description,
    imgUrl,
    onClick = () => {},
    contentType = "default",
    trackInteraction,
    type,
    url,
  } = props;

  const { pathname } = useLocation();

  const PAGE_NAME = pathname.split("/")[1].toUpperCase() || "N/A";

  const trackOnClick = (event, callback) => {
    trackInteraction({
      action: event.currentTarget.dataset?.action,
      page: PAGE_NAME,
      element: event.currentTarget.dataset?.element,
    });

    if(["URL", "PDF"].includes(type)) {
      window.open(url, "_blank");
      return;
    }

    callback();
  };

  if (contentType === "VIDEO") {
    return <VideoPlayerWithTracking {...props} />;
  }

  if (contentType === "SUBSECTION") {
    return (
      <div className="contents-card">
        <img src={imgUrl} alt={title} />

        <div className="contents-card-content">
          <span className="contents-card-title">{title}</span>
          <span className="contents-card-description">{description}</span>
          <button
            className="contents-card-button"
            data-element={title}
            data-action="SUBSECTION_CLICK"
            onClick={(event) => trackOnClick(event, onClick)}
          >
            Ir <FaChevronRight />
          </button>
        </div>
      </div>
    );
  }

  return <></>;
}

const CardWithTracking = withTracking(mapTrackingToProps)(Card);

export default CardWithTracking;
